import {alias, createModelSchema, reference} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";


export class CardModel extends BaseObject {

    static schema() {
        return reference("uid", (uid, cb) => {
            return cb(null, RedactorUtils.getCard(uid));
        });
    }

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._guard = new GuardConfig();
        this._style = 0;

        this._rarity = 0;
        this._points = 0;
        this._reward = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get style() {
        return this._style;
    }

    set style(value) {
        this._style = value;
    }

    get rarity() {
        return this._rarity;
    }

    set rarity(value) {
        this._rarity = value;
    }

    get points() {
        return this._points;
    }

    set points(value) {
        this._points = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (!Number.isInteger(this.style) || this.style < 0 || this.style > 15) {
            return false;
        }

        if (!Number.isInteger(this.rarity) || this.rarity <= 0 || this.rarity > 5) {
            return false;
        }

        if (!Number.isInteger(this.points) || this.points < 0) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._id = "";
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CardModel());
        } else if (target instanceof CardModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CardModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _guard: alias("guard", GuardConfig.schema()),
    _style: alias("style", Schema.primitive()),
    _rarity: alias("rarity", Schema.primitive()),
    _points: alias("points", Schema.primitive()),
    _reward: alias("reward", RewardModel.schema())
});